import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import IconItem from 'blockscope/components/common/icon/IconItem';

const IconGroup = ({ icons, className, ...rest }) => (
  <div className={classNames('icon-group', className)} {...rest}>
    {icons.map((icon, index) => (
      <IconItem {...icon} key={index} />
    ))}
  </div>
);

IconGroup.propTypes = {
  icons: PropTypes.array.isRequired,
  className: PropTypes.string,
};

export default IconGroup;
